module.exports = __webpack_public_path__ + "static/media/icon-upload.d8847651.svg";